import { render, staticRenderFns } from "./SubFooter.vue?vue&type=template&id=7af4b204&scoped=true&lang=html&"
var script = {}
import style0 from "./SubFooter.vue?vue&type=style&index=0&id=7af4b204&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4b204",
  null
  
)

export default component.exports